export default "__VITE_ASSET__BvBFuQ7___"